import type { EditorView } from '@atlaskit/editor-prosemirror/view';
import { history } from '@atlaskit/prosemirror-history/history';

export const resetProsemirrorHistoryPlugin = (editorView: EditorView): void => {
	const { state } = editorView;
	const newState = state.reconfigure({
		plugins: state.plugins.filter((p) => {
			return p.spec.key !== history().spec.key;
		}),
	});
	editorView.updateState(newState);

	const { state: updatedState } = editorView;
	const newerState = updatedState.reconfigure({
		plugins: updatedState.plugins.concat(history()),
	});
	editorView.updateState(newerState);
};
